<small class="color--muted">{{ product?.unit?.type }}</small>
<a
    class="pill pill--product"
    *ngIf="isLoading">
    <app-loading-message></app-loading-message>
</a>
